import {
  getGridNumericOperators,
  getGridStringOperators,
  GridFilterModel,
  GridSortModel,
  GridPaginationModel,
  getGridDateOperators,
} from '@mui/x-data-grid';

const gridToSieve = new Map([
  ['=', '=='],
  ['equals', '==*'],
  ['contains', '@=*'],
  ['startsWith', '_=*'],
  ['endsWith', '_-=*'],
  ['is', '=='],
  ['not', '!='],
  ['after', '>'],
  ['onOrAfter', '>='],
  ['before', '<'],
  ['onOrBefore', '<='],
]);
export const getCorrespondingSieveOperator = (operator: string) => {
  const mappedOperator = gridToSieve.get(operator);
  return mappedOperator ?? operator;
};

export const getNumericOperators = () => {
  const dataGridOperators = getGridNumericOperators();
  const operators = dataGridOperators.filter((entry: any) => {
    const allowedOperators = ['=', '!=', '<', '<=', '>', '>='];
    return allowedOperators.includes(entry.value);
  });
  return operators;
};
export const getStringOperators = () => {
  const dataGridOperators = getGridStringOperators();
  const operators = dataGridOperators.filter((entry: any) => {
    const allowedOperators = ['equals', 'contains', 'startsWith', 'endsWith'];
    return allowedOperators.includes(entry.value);
  });
  return operators;
};
export const getDateOperators = () => {
  const dataGridOperators = getGridDateOperators();
  const operators = dataGridOperators.filter((entry: any) => {
    const allowedOperators = ['is', 'not', 'after', 'onOrAfter', 'before', 'onOrBefore'];
    return allowedOperators.includes(entry.value);
  });
  return operators;
};
export const getSieveStringFromFilterModel = (filterModel: GridFilterModel) => {
  const filterItems: string[] = [];
  filterModel?.items?.forEach(entry => {
    if (!entry.field) return;
    if (!entry.value) return;
    if (!entry.operator) return;
    const operator = getCorrespondingSieveOperator(entry.operator);
    if (operator === 'between') {
      const [lowerBound, upperBound] = entry.value as [string, string];
      filterItems.push(`${entry.field}>=${lowerBound}`);
      filterItems.push(`${entry.field}<=${upperBound}`);
      return;
    }
    filterItems.push(`${entry.field}${operator}${entry.value.toLowerCase()}`);
  });
  return filterItems.join(',');
};
export const getSieveStringFromSortingModel = (sortingModel: GridSortModel) => {
  const sortItems = sortingModel.map(entry => {
    const { field, sort } = entry;
    const sortSign = sort === 'asc' ? '' : '-';
    return `${sortSign}${field}`;
  });
  return sortItems.join(',');
};
export const getQueryStringForSieve = (
  paginationModel: GridPaginationModel,
  sortingModel: GridSortModel,
  filteringModel?: GridFilterModel,
) => {
  const { page, pageSize } = paginationModel;
  const queryItems = [];
  queryItems.push(`page=${page + 1}`);
  queryItems.push(`pageSize=${pageSize}`);
  const sortString = getSieveStringFromSortingModel(sortingModel);
  if (sortString !== '') queryItems.push(`sorts=${sortString}`);
  if (filteringModel) {
    const filterString = getSieveStringFromFilterModel(filteringModel);
    if (filterString !== '') queryItems.push(`filters=${filterString}`);
  }
  return queryItems;
};
